$(document).ready(function() {
  $('details.facets__disclosure-vertical.js-filter').attr('open', true);

//Hover for main navbar
    let items = document
        .querySelector(".header__inline-menu")
        .querySelectorAll("details");
    items.forEach((item) => {
        item.addEventListener("mouseover", () => {
            item.setAttribute("open", true);
            item.querySelector("summary").setAttribute("aria-expanded", "true");
            item.addEventListener("mouseout", () => {
                item.removeAttribute("open");
                item.querySelector("summary").setAttribute("aria-expanded", "false");
            });
        });
    });

    $("#HeaderMenu-torneo-back-to-the-roots span").addClass("events-navbar-style");
    $("#HeaderMenu-torneo-back-to-the-roots").addClass("events-navbar-style");
  

});